import _objectSpread from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { schema } from '@rest-hooks/normalizr';
import { Endpoint } from '@rest-hooks/endpoint';
import EntityRecord from "./EntityRecord.js";
import { NotImplementedError } from "./errors.js";
import paramsToString from "./paramsToString.js";
/**
 * Represents an entity to be retrieved from a server.
 * Typically 1:1 with a url endpoint.
 *
 * This can be a useful organization for many REST-like API patterns.
 *
 * @deprecated Use Resource directly in the future
 */

var SimpleResource = /*#__PURE__*/function (_EntityRecord) {
  _inherits(SimpleResource, _EntityRecord);

  var _super = _createSuper(SimpleResource);

  function SimpleResource() {
    _classCallCheck(this, SimpleResource);

    return _super.apply(this, arguments);
  }

  _createClass(SimpleResource, null, [{
    key: "toString",
    value: // typescript todo: require subclasses to implement

    /** Used as base of url construction */
    function toString() {
      return "".concat(this.name, "::").concat(this.urlRoot);
    }
    /** Returns the globally unique identifier for this SimpleResource */

  }, {
    key: "key",
    get: function get() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== 'production') {
        if (this.urlRoot === undefined) {
          throw new Error("urlRoot is not defined for Resource \"".concat(this.name, "\"\n\n  Resources require a 'static urlRoot' or 'static get key()' defined.\n  (See https://resthooks.io/docs/api/resource#static-urlroot-string)\n"));
        }
      }

      return this.urlRoot;
    }
    /** URL to find this SimpleResource */

    /** Get the url for a SimpleResource
     *
     * Default implementation conforms to common REST patterns
     */

  }, {
    key: "url",
    value: function url(urlParams) {
      if (Object.prototype.hasOwnProperty.call(urlParams, 'url') && urlParams.url && typeof urlParams.url === 'string') {
        return urlParams.url;
      }

      if (this.pk(urlParams) !== undefined) {
        return "".concat(this.urlRoot.replace(/\/$/, ''), "/").concat(this.pk(urlParams));
      }

      return this.urlRoot;
    }
    /** Get the url for many SimpleResources
     *
     * Default implementation conforms to common REST patterns
     */

  }, {
    key: "listUrl",
    value: function listUrl() {
      var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Object.keys(searchParams).length) {
        return "".concat(this.urlRoot, "?").concat(paramsToString(searchParams));
      }

      return this.urlRoot;
    }
    /** Perform network request and resolve with json body */

  }, {
    key: "fetch",
    value: function fetch(input, init) {
      // typescript currently doesn't allow abstract static methods
      throw new NotImplementedError();
    }
    /** Perform network request and resolve with HTTP Response */

  }, {
    key: "fetchResponse",
    value: function fetchResponse(input, init) {
      // typescript currently doesn't allow abstract static methods
      throw new NotImplementedError();
    }
    /** Init options for fetch - run at fetch */

  }, {
    key: "getFetchInit",
    value: function getFetchInit(init) {
      return init;
    }
    /** Init options for fetch - run at render */

  }, {
    key: "useFetchInit",
    value: function useFetchInit(init) {
      return init;
    }
    /** Get the request options for this SimpleResource */

  }, {
    key: "getEndpointExtra",
    value: function getEndpointExtra() {
      return {
        errorPolicy: function errorPolicy(error) {
          return error.status >= 500 ? 'soft' : undefined;
        }
      };
    }
    /** Field where endpoint cache is stored */

    /** Used to memoize endpoint methods
     *
     * Relies on existance of runInit() member.
     */

  }, {
    key: "memo",
    value: function memo(name, construct) {
      if (!Object.hasOwnProperty.call(this, this.cacheSymbol)) {
        this[this.cacheSymbol] = {};
      }

      var cache = this[this.cacheSymbol];

      if (!(name in cache)) {
        cache[name] = construct();
      }

      return cache[name].useFetchInit();
    }
    /** Base endpoint that uses all the hooks provided by Resource  */

  }, {
    key: "endpoint",
    value: function endpoint() {
      var _this = this;

      return this.memo('#endpoint', function () {
        // eslint-disable-next-line
        var resource = _this;

        var instanceFetch = _this.fetch.bind(_this);

        var url = _this.url.bind(_this);

        return new Endpoint(function (params) {
          return instanceFetch(this.url(params), this.getFetchInit());
        }, _objectSpread(_objectSpread({}, _this.getEndpointExtra()), {}, {
          key: function key(params) {
            return "".concat(this.method, " ").concat(this.url(params));
          },
          url: url,
          fetchInit: {},
          useFetchInit: function useFetchInit() {
            this.fetchInit = resource.useFetchInit(this.fetchInit);
            return this;
          },
          getFetchInit: function getFetchInit(body) {
            if (isPojo(body)) {
              body = JSON.stringify(body);
            }

            return resource.getFetchInit(_objectSpread(_objectSpread({}, this.fetchInit), {}, {
              method: this.method,
              signal: this.signal,
              body: body
            }));
          },
          method: 'GET',
          signal: undefined
        }));
      });
    }
    /** Base endpoint but for sideEffects */

  }, {
    key: "endpointMutate",
    value: function endpointMutate() {
      var instanceFetch = this.fetch.bind(this);
      var endpoint = this.endpoint();
      return this.memo('#endpointMutate', function () {
        return endpoint.extend({
          fetch: function fetch(params, body) {
            return instanceFetch(this.url(params), this.getFetchInit(body));
          },
          sideEffect: true,
          method: 'POST'
        });
      });
    }
    /** Endpoint to get a single entity */

  }, {
    key: "detail",
    value: function detail() {
      var _this2 = this;

      var endpoint = this.endpoint();
      return this.memo('#detail', function () {
        return endpoint.extend({
          schema: _this2
        });
      });
    }
    /** Endpoint to get a list of entities */

  }, {
    key: "list",
    value: function list() {
      var _this3 = this;

      var endpoint = this.endpoint();
      return this.memo('#list', function () {
        return endpoint.extend({
          schema: [_this3],
          url: _this3.listUrl.bind(_this3)
        });
      });
    }
    /** Endpoint to create a new entity (post) */

  }, {
    key: "create",
    value: function create() {
      var _this4 = this;

      //Partial<AbstractInstanceType<T>>
      var endpoint = this.endpointMutate();
      return this.memo('#create', function () {
        return endpoint.extend({
          schema: _this4,
          url: _this4.listUrl.bind(_this4)
        });
      });
    }
    /** Endpoint to update an existing entity (put) */

  }, {
    key: "update",
    value: function update() {
      var _this5 = this;

      var endpoint = this.endpointMutate();
      return this.memo('#update', function () {
        return endpoint.extend({
          method: 'PUT',
          schema: _this5
        });
      });
    }
    /** Endpoint to update a subset of fields of an existing entity (patch) */

  }, {
    key: "partialUpdate",
    value: function partialUpdate() {
      var _this6 = this;

      var endpoint = this.endpointMutate();
      return this.memo('#partialUpdate', function () {
        return endpoint.extend({
          method: 'PATCH',
          schema: _this6
        });
      });
    }
    /** Endpoint to delete an entity (delete) */

  }, {
    key: "delete",
    value: function _delete() {
      var _this7 = this;

      var endpoint = this.endpointMutate();
      return this.memo('#delete', function () {
        return endpoint.extend({
          fetch: function fetch(params) {
            return endpoint.fetch.call(this, params).then(function () {
              return params;
            });
          },
          method: 'DELETE',
          schema: new schema.Delete(_this7)
        });
      });
    }
    /** @deprecated */

  }, {
    key: "fetchOptionsPlugin",
    value: function fetchOptionsPlugin(options) {
      /* istanbul ignore next */
      return this.getFetchInit(options);
    }
    /** @deprecated */

  }, {
    key: "getFetchOptions",
    value: function getFetchOptions() {
      /* istanbul ignore next */
      return this.getEndpointExtra();
    }
    /** @deprecated */

  }, {
    key: "detailShape",
    value: function detailShape() {
      var endpoint = this.detail();
      var fetch = endpoint.fetch.bind(endpoint);
      return _objectSpread(_objectSpread({}, endpoint), {}, {
        fetch: fetch
      });
    }
    /** @deprecated */

  }, {
    key: "listShape",
    value: function listShape() {
      var endpoint = this.list();
      var fetch = endpoint.fetch.bind(endpoint);
      return _objectSpread(_objectSpread({}, endpoint), {}, {
        fetch: fetch
      });
    }
    /** @deprecated */

  }, {
    key: "createShape",
    value: function createShape() {
      var endpoint = this.create();
      var fetch = endpoint.fetch.bind(endpoint);
      return _objectSpread(_objectSpread({}, endpoint), {}, {
        fetch: fetch
      });
    }
    /** @deprecated */

  }, {
    key: "updateShape",
    value: function updateShape() {
      var endpoint = this.update();
      var fetch = endpoint.fetch.bind(endpoint);
      return _objectSpread(_objectSpread({}, endpoint), {}, {
        fetch: fetch
      });
    }
    /** @deprecated */

  }, {
    key: "partialUpdateShape",
    value: function partialUpdateShape() {
      var endpoint = this.partialUpdate();
      var fetch = endpoint.fetch.bind(endpoint);
      return _objectSpread(_objectSpread({}, endpoint), {}, {
        fetch: fetch
      });
    }
    /** @deprecated */

  }, {
    key: "deleteShape",
    value: function deleteShape() {
      var endpoint = this.delete();
      var fetch = endpoint.fetch.bind(endpoint);
      return _objectSpread(_objectSpread({}, endpoint), {}, {
        fetch: fetch
      });
    }
  }]);

  return SimpleResource;
}(EntityRecord); // We're only allowing this to get set for descendants but
// by default we want Typescript to treat it as readonly.


export { SimpleResource as default };
SimpleResource.urlRoot = void 0;
SimpleResource.cacheSymbol = Symbol('memo');
Object.defineProperty(SimpleResource.prototype, 'url', {
  get: function get() {
    if (this.__url !== undefined) return this.__url; // typescript thinks constructor is just a function

    var Static = this.constructor;
    return Static.url(this);
  },
  set: function set(url) {
    this.__url = url;
  }
});
var proto = Object.prototype;
var gpo = Object.getPrototypeOf;

function isPojo(obj) {
  if (obj === null || typeof obj !== 'object') {
    return false;
  }

  return gpo(obj) === proto;
}